import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

export default function MfcChatPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [client, setClient] = useState(null);
  const [sending, setSending] = useState(false);
  const bottomRef = useRef(null);

  const loadMessages = () => {
    axios.get(`/api/mfc-clients/${id}/messages`).then(r => {
      setMessages(r.data);
      axios.put(`/api/mfc-clients/${id}/messages/read`).catch(() => {});
    }).catch(() => {});
  };

  const loadClient = () => {
    axios.get("/api/mfc-clients").then(r => {
      const c = r.data.find(u => u.id === parseInt(id));
      if (c) setClient(c);
    }).catch(() => {});
  };

  useEffect(() => {
    loadClient();
    loadMessages();
    const interval = setInterval(loadMessages, 8000);
    return () => clearInterval(interval);
  }, [id]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const send = async () => {
    if (!text.trim() || sending) return;
    setSending(true);
    try {
      await axios.post(`/api/mfc-clients/${id}/messages`, { text: text.trim() });
      setText("");
      loadMessages();
    } catch {}
    setSending(false);
  };

  const handleKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); }
  };

  const ReadCheck = ({ read }) => (
    <span style={{ marginLeft: 4, fontSize: 12, opacity: read ? 1 : 0.5 }}>
      {read ? "✓✓" : "✓"}
    </span>
  );

  return (
    <div style={{ padding: "24px 32px", height: "100%", display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 20 }}>
        <button onClick={() => navigate("/mfc-service")} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer" }}>&larr;</button>
        <div>
          <h2 style={{ margin: 0, fontSize: 18 }}>
            Чат: {client ? (client.name || client.email || client.phone || `#${id}`) : `Клиент #${id}`}
          </h2>
          {client && client.phone && <span style={{ fontSize: 13, color: "#64748b" }}>{client.phone}</span>}
        </div>
      </div>

      <div style={{ flex: 1, overflowY: "auto", background: "#f8fafc", borderRadius: 12, padding: 20, display: "flex", flexDirection: "column", gap: 10, minHeight: 0 }}>
        {messages.length === 0 && (
          <p style={{ color: "#94a3b8", textAlign: "center", marginTop: 60 }}>Сообщений пока нет</p>
        )}
        {messages.map(m => (
          <div key={m.id} style={{
            alignSelf: m.sender === "admin" ? "flex-end" : "flex-start",
            background: m.sender === "admin" ? "#2bb5a0" : "#fff",
            color: m.sender === "admin" ? "#fff" : "#1e293b",
            padding: "10px 16px",
            borderRadius: 12,
            maxWidth: "70%",
            boxShadow: m.sender === "client" ? "0 1px 4px rgba(0,0,0,0.06)" : "none"
          }}>
            <div style={{ fontSize: 14, whiteSpace: "pre-wrap" }}>{m.text}</div>
            <div style={{ fontSize: 10, opacity: 0.6, marginTop: 4, display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
              {new Date(m.created_at).toLocaleString("ru-RU", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit" })}
              {m.sender === "admin" && <ReadCheck read={m.read} />}
            </div>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      <div style={{ display: "flex", gap: 10, marginTop: 16, alignItems: "flex-end" }}>
        <textarea
          value={text}
          onChange={e => setText(e.target.value)}
          onKeyDown={handleKey}
          placeholder="Написать ответ..."
          rows={2}
          style={{ flex: 1, border: "1px solid #e2e8f0", borderRadius: 10, padding: "10px 14px", fontSize: 14, resize: "none", fontFamily: "inherit", outline: "none" }}
        />
        <button
          onClick={send}
          disabled={sending || !text.trim()}
          style={{ padding: "10px 20px", background: "#2bb5a0", color: "#fff", border: "none", borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: "pointer", opacity: (!text.trim() || sending) ? 0.5 : 1 }}
        >
          Отправить
        </button>
      </div>
    </div>
  );
}
